var cookie_consent_opener = document.getElementsByClassName("cookie_consent_open");

for (var i=0; i < cookie_consent_opener.length; i++) {
    cookie_consent_opener[i].onclick = function(e){
        e.preventDefault();
        e.stopPropagation();
        window.UC_UI.showFirstLayer();
    }
};
